"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var Link_1 = __importDefault(require("atomicComponents/atoms/Text/Link"));
var general_1 = require("utils/general");
var StepWrapper = (0, styles_1.styled)(Link_1.default, { shouldForwardProp: (0, general_1.omitProps)('compressed') })(function (_a) {
    var theme = _a.theme, compressed = _a.compressed;
    return ({
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: 8,
        width: '100%',
        ':hover': {
            backgroundColor: theme.palette.secondary.light,
        },
        padding: theme.spacing(compressed ? 1.5 : 2.5, 2),
    });
});
exports.default = StepWrapper;
